export const CAMPAIGN_SENDER_DOMAIN = 'news.brawlermail.com';
export const DEFAULT_CAMPAIGN_SENDER =
  'David at BookieBrawler <david@news.brawlermail.com>';

const DEFAULT_SENDER_BRAND = 'BookieBrawler';
const RFC_FROM_PATTERN = /^[^<>]+<\s*[^@\s<>]+@[^@\s<>]+\s*>$/;
const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const NAME_PATTERN = /^[a-zA-Z][a-zA-Z0-9._-]{0,40}$/;

function senderDomain(value: string): string | null {
  const trimmed = value.trim();
  const match = trimmed.match(/<\s*([^<>\s]+@[^<>\s]+)\s*>$/);
  const address = match?.[1] ?? trimmed;
  const at = address.lastIndexOf('@');
  return at > 0 ? address.slice(at + 1).toLowerCase() : null;
}

export function expandCampaignFromPreview(raw: string): string | null {
  const trimmed = raw.trim();
  if (!trimmed) return DEFAULT_CAMPAIGN_SENDER;

  if (RFC_FROM_PATTERN.test(trimmed)) {
    return senderDomain(trimmed) === CAMPAIGN_SENDER_DOMAIN ? trimmed : null;
  }

  let local: string;
  let display: string;
  if (EMAIL_PATTERN.test(trimmed)) {
    if (senderDomain(trimmed) !== CAMPAIGN_SENDER_DOMAIN) return null;
    const at = trimmed.indexOf('@');
    local = trimmed.slice(0, at).toLowerCase();
    display = local.charAt(0).toUpperCase() + local.slice(1);
  } else if (NAME_PATTERN.test(trimmed)) {
    local = trimmed.toLowerCase();
    display = local.charAt(0).toUpperCase() + local.slice(1);
  } else {
    return null;
  }

  return `${display} at ${DEFAULT_SENDER_BRAND} <${local}@${CAMPAIGN_SENDER_DOMAIN}>`;
}

export function senderShape(
  raw: string,
): 'default' | 'invalid' | 'verbatim' | 'expanded' {
  const trimmed = raw.trim();
  if (!trimmed) return 'default';
  if (RFC_FROM_PATTERN.test(trimmed)) {
    return senderDomain(trimmed) === CAMPAIGN_SENDER_DOMAIN ? 'verbatim' : 'invalid';
  }
  if (NAME_PATTERN.test(trimmed)) return 'expanded';
  if (EMAIL_PATTERN.test(trimmed)) {
    return senderDomain(trimmed) === CAMPAIGN_SENDER_DOMAIN ? 'expanded' : 'invalid';
  }
  return 'invalid';
}
